<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Edit Data Event & Tips</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  v-model.trim="corporateActionDataNew.corporate_action_title"
                  label="Title"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Title"
                  :is-valid="corporateActionData.corporate_action_title && corporateActionData.corporate_action_title.length > 65 ? false : null"
                  invalid-feedback="Title more than 65 characters"
                  @change="handleCorporateActionTitle"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  id="corporate_slug"
                  label="Url Name"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Url Name"
                  v-model.trim="corporateActionDataNew.corporate_action_slug"
                  @change="handleCorporateActionSlug"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="Meta Description"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Meta Description"
                  v-model="corporateActionDataNew.meta_info_description"
                  @change="handleMetaDescription"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="Meta Keyword"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Meta Keyword"
                  v-model="corporateActionDataNew.meta_info_keyword"
                  @change="handleMetaKeyword"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="Jenis Article"
                  :options="options"
                  required
                  horizontal
                  v-model="corporateActionDataNew.corporate_action_type"
                  @change="handleCorporateActionType"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="Author"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Author"
                  v-model.trim="corporateActionDataNew.corporate_action_author"
                  @change="handleAuthor"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="Active Date"
                  class="mb-0"
                  type="date"
                  required
                  horizontal
                  placeholder="Active Date"
                  v-model.trim="corporateActionDataNew.active_date"
                  @change="handleActiveDate"
              />
            </CCol>
          </CRow>
          <CRow class="form-group mt-5">
            <CCol :col="12">
              <a>Content</a>
              <editor
                  id="editor"
                  :api-key="key"
                  :init="initOption"
                  v-model="corporateActionDataNew.corporate_action_content"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <div class="warning-input" v-if="imageIs === 'KOSONG'">
                Foto Ilustrasi di perlukan
              </div>
              <CInputFile
                  label="File Illustration"
                  horizontal
                  type="file"
                  :is-valid="false"
                  :invalid-feedback="error.attachment_corporate_action_photo_url.message"
                  @change="readURL"
              >
                <template v-slot:label-after-input>
                  File size should be below 250KB and Optimize picture size is 980px x 400px.
                </template>
              </CInputFile>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <img class="image-ilustrasi" id="myImg" v-if="url" :src="url"/>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="ALT Illustration"
                  class="mb-0"
                  type="text"
                  horizontal
                  placeholder="ALT Illustration"
                  v-model="corporateActionDataNew.alt_photo"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInputFile
                  label="File Sub Illustration"
                  horizontal
                  type="file"
                  :isValid="false"
                  :invalidFeedback="error.attachment_corporate_action_sub_photo_url.message"
                  @change="handleCorporateActionSubPhotoUrl"
              >
                <template v-slot:label-after-input>
                  File size should be below 150KB and Optimize picture size is 300px x 200px.
                </template>
              </CInputFile>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <img class="image-ilustrasi" id="myImg" v-if="subPhotoUrl" :src="subPhotoUrl"/>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="ALT Sub Illustration"
                  class="mb-0"
                  type="text"
                  horizontal
                  placeholder="ALT Sub Illustration"
                  v-model="corporateActionDataNew.alt_sub_photo"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <div role="group" class="form-group form-row">
                <label class="col-form-label col-sm-3">Hashtag</label>
                <div class="col-sm-9">
                  <multiselect
                      horizontal
                      v-model="corporateActionDataNew.corporate_action_hashtag_ids"
                      :options="optionsHashtag"
                      :multiple="true"
                      @change="handleHashtagCorporateAction">
                  </multiselect>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="Show in related Event & Tips?"
                  :options="optionsShowRelated"
                  required
                  horizontal
                  v-model="corporateActionDataNew.corporate_action_related_show_option"
                  @change="handleShowRelatedCorporateAction"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="Article Info"
                  :options="optionsArticleInfo"
                  required
                  horizontal
                  v-model="corporateActionData.article_info"
                  @change="handleShowArticleInfo"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="Suggestion Article"
                  :options="optionsSuggestionArticle"
                  required
                  horizontal
                  v-model="corporateActionData.is_suggested"
                  @change="handleShowIsSuggested"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="Status"
                  :options="optionsStatus"
                  required
                  horizontal
                  v-model="corporateActionDataNew.status"
                  @change="handleStatusCorporateAction"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton
                  color="success"
                  class="float-right"
                  @click="updateCorporateAction"
              >Submit
              </CButton
              >
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import jwt from "jsonwebtoken";
import Editor from "@tinymce/tinymce-vue";
import Multiselect from 'vue-multiselect'
import {validateImageHeightAndWidth} from "./helper";
import initTinymce from "@/app/constants/initTinymce";

export default {
  name: "CorporateActionEdit",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.usersOpened = from.fullPath.includes("usercreate");
    });
  },
  components: {
    editor: Editor,
    Multiselect
  },
  data() {
    return {
      corporateActionDataNew: {},
      corporateActionData: {},
      imageIs: "ADA",
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      options: ["Event", "Tips"],
      optionsStatus: ["ACTIVE", "INACTIVE"],
      optionsHashtag: [],
      optionsHashtag2: ["ACTIVE", "INACTIVE", "test", "test2"],
      optionsShowRelated: ["YES", "NO", "ALWAYS SHOW"],
      optionsArticleInfo: ["MITRA" ,"SELLER"],
      optionsSuggestionArticle: ["YES", "NO"],
      url: null,
      alt_photo: "",
      subPhotoUrl: null,
      alt_sub_photo: "",
      arrayPhoto: [],
      initOption: initTinymce.init,
      key: initTinymce.key,
      error: {
        attachment_corporate_action_photo_url: {
          message: ''
        },
        attachment_corporate_action_sub_photo_url: {
          message: ''
        }
      }
    };
  },
  mounted() {
    this.authentication();
    this.getHashtagList();
    this.getDataByID();
  },
  computed: {},
  methods: {
    getDataByID() {
      let CorporateActionID = this.$route.params.id;
      axios
            .get(`${this.domain}/v2/event_and_tips/admin/${CorporateActionID}`, {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            // JSON responses are automatically parsed.
            this.corporateActionDataNew = response.data.data;
            this.corporateActionDataNew.active_date = moment(
                String(this.corporateActionDataNew.active_date)
            ).format("YYYY-MM-DD");
            this.corporateActionData = response.data.data;
            this.corporateActionData.is_suggested = this.corporateActionData.is_suggested ? "YES" : "NO"
            this.corporateActionData.corporate_action_hashtag_ids = this.corporateActionData.corporate_action_hashtag_ids ? this.corporateActionData.corporate_action_hashtag_ids.split(',').filter(val => val) : '';
            this.content1 = this.corporateActionDataNew.corporate_action_content;
            this.url = this.corporateActionDataNew.attachment_corporate_action_photo_url;
            this.subPhotoUrl = this.corporateActionDataNew.attachment_corporate_action_sub_photo_url
            this.corporateActionData.meta_info_description = this.corporateActionDataNew.meta_info_description
            this.corporateActionData.meta_info_keyword = this.corporateActionDataNew.meta_info_keyword
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.response.data.desc.id,
            });
          });
    },
    getHashtagList() {
      axios
          .get(`${this.domain}/v1/corporate_action_hashtag/data`, {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            // JSON responses are automatically parsed.
            let data = [];
            response.data.data.forEach(element => {
              data.push(
                  element.corporate_action_hashtag_title,
              )
            });
            this.optionsHashtag = data
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.response.data.desc.id,
            });
          });
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
          data.account_group === "MARKETING" ||
          data.account_group === "ADMIN" ||
          data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({path: `/`});
      }
    },
    goBack() {
      this.usersOpened
          ? this.$router.go(-1)
          : this.$router.push({path: "/management/corporate"});
    },
    handleCorporateActionTitle(event) {
      var slug = event
          .replaceAll(/[^A-Za-z0-9 -]/g, "")
          .replaceAll(" ", "-")
          .replaceAll("--", "-")
          .toLowerCase()
          .trim();
      document.getElementById("corporate_slug").value = slug;
      this.corporateActionData.corporate_action_slug = slug;
      this.corporateActionData.corporate_action_title = event;
    },
    handleCorporateActionSlug(event) {
      var slug = event
          .replaceAll(/[^A-Za-z0-9 -]/g, "")
          .replaceAll(" ", "-")
          .replaceAll("--", "-")
          .toLowerCase()
          .trim();
      document.getElementById("corporate_slug").value = slug;
      this.corporateActionData.corporate_action_slug = slug;
    },
    handleCorporateActionType(event) {
      this.corporateActionData.corporate_action_type = event.target.value;
    },
    handleAuthor(event) {
      this.corporateActionData.corporate_action_author = event;
    },
    handleActiveDate(event) {
      this.corporateActionData.active_date = event;
    },
    handleCorporateActionContent(event) {
      this.corporateActionData.corporate_action_content = event;
    },
    handleStatusCorporateAction(event) {
      this.corporateActionData.status = event.target.value;
    },
    handleShowRelatedCorporateAction(event) {
      this.corporateActionData.corporate_action_related_show_option = event.target.value;
    },
    handleShowArticleInfo(event) {
      this.corporateActionData.article_info = event.target.value;
    },
    handleShowIsSuggested(event) {
      this.corporateActionData.is_suggested = event.target.value;
    },
    handleHashtagCorporateAction(event) {
      this.corporateActionData.corporate_action_hashtag_ids = event.target.value;
    },
    handleMetaDescription(event) {
      this.corporateActionData.meta_info_description = event;
    },
    handleMetaKeyword(event) {
      this.corporateActionData.meta_info_keyword = event;
    },
    async handleCorporateActionSubPhotoUrl(event) {
      const file = event[0];
      const {dataUrl, err} = await validateImageHeightAndWidth(file, true)
      this.subPhotoUrl = dataUrl
      this.error.attachment_corporate_action_sub_photo_url.message = err
      this.corporateActionData.attachment_corporate_action_sub_photo_url = event[0];
    },
    async readURL(e) {
      const file = e[0];
      const {dataUrl, err} = await validateImageHeightAndWidth(file)
      this.url = dataUrl
      this.error.attachment_corporate_action_photo_url.message = err
      this.corporateActionDataNew.attachment_corporate_action_photo_url = e[0];
    },
    updateCorporateAction() {
      if (
          this.corporateActionData.attachment_corporate_action_photo_url["size"] >
          250000
      ) {

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Picture too big. Please upload below 250 KB",
        });
        return;
      } else {
        if (this.error.attachment_corporate_action_photo_url.message) {
          Swal.fire({
          icon: "error",
          title: "Oops...",
          text: this.error.attachment_corporate_action_photo_url.message,
        });
        return;
        }
      }

      if (this.corporateActionData.attachment_corporate_action_sub_photo_url['size'] > 150000) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Picture too big. Please upload below 150 KB"
          });
          return;
        }
        if (this.error.attachment_corporate_action_sub_photo_url.message) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: this.error.attachment_corporate_action_sub_photo_url.message
          });
          return;
        }

      var today = new Date();
      var time = ` ${today.getHours()}:${today.getMinutes()}`;
      var activeDate = moment(
          this.corporateActionData.active_date + time
      ).format();
      this.corporateActionData.corporate_action_author = this.corporateActionDataNew.corporate_action_author;
      let CorporateActionID = this.$route.params.id;
      let formData = new FormData();
      formData.append(
          "corporate_action_title",
          this.corporateActionData.corporate_action_title
      );
      formData.append(
          "corporate_action_slug",
          this.corporateActionData.corporate_action_slug
      );
      formData.append(
          "corporate_action_type",
          this.corporateActionData.corporate_action_type
      );
      formData.append(
          "corporate_action_author",
          this.corporateActionData.corporate_action_author
      );
      formData.append("active_date", activeDate);
      formData.append(
          "corporate_action_content",
          this.corporateActionData.corporate_action_content
      );
      formData.append(
          "attachment_corporate_action_photo_url",
          this.corporateActionData.attachment_corporate_action_photo_url
      );
      formData.append("alt_photo", this.corporateActionData.alt_photo);
      formData.append(
          "attachment_corporate_action_sub_photo_url",
          this.corporateActionData.attachment_corporate_action_sub_photo_url
      );
      formData.append("alt_sub_photo", this.corporateActionData.alt_sub_photo);
      formData.append("status", this.corporateActionData.status);
      formData.append(
          "corporate_action_hashtag_ids",
          this.corporateActionData.corporate_action_hashtag_ids + ','
      );
      formData.append(
          "corporate_action_related_show_option",
          this.corporateActionData.corporate_action_related_show_option
      );
      formData.append("article_info", this.corporateActionData.article_info);
      formData.append("is_suggested", this.corporateActionData.is_suggested === "YES" ? true : false);
      formData.append("meta_info_keyword", this.corporateActionData.meta_info_keyword);
      formData.append("meta_info_description", this.corporateActionData.meta_info_description);
      axios
          .put(
              `${this.domain}/v2/event_and_tips/admin/${CorporateActionID}`,
              formData,
              {
                headers: {
                  Authorization: this.token,
                  "Content-Type": "application/json",
                },
              }
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            Swal.fire({
              icon: "success",
              title: `Corporate Action Data Updated`,
              showConfirmButton: false,
              timer: 2000,
            });
            this.items = response.data.data;
            //this.$router.push({ path: `/management/corporate` });
          })
          .catch((err) => {
            this.corporateActionDataNew.active_date = moment(
                String(this.corporateActionDataNew.active_date)
            ).format("YYYY-MM-DD");
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.response.data.desc.id,
            });
          });
    },
  },
  validator(val) {
    return val ? val.length >= 4 : false;
  },
};
</script>

<style scoped>
@import "./Corporate.css";
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
